import {createAsyncThunk} from '@/app/store/createAsyncThunk';
import {LocationPoint} from '@/common/interfaces/location';

export const addRecentLocationAction = createAsyncThunk<{location: LocationPoint}, void, void>(
	'locationsHistory/addRecentLocation',
	async ({location}, {context, success}) => {
		await context.backendAPI.location.addRecentLocation(location.id);
		return success();
	},
);
